import React from 'react';

export const ChevronDown = ({
  className,
  color,
  width,
  height,
}: {
  className?: string;
  color?: string;
  width?: string;
  height?: string;
}) => (
  <svg
    width={width ?? '8'}
    height={height ?? '5'}
    viewBox="0 0 8 5"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M7.08584 0.930358C7.03187 0.876281 6.96777 0.833378 6.8972 0.804106C6.82664 0.774833 6.75099 0.759766 6.67459 0.759766C6.59819 0.759766 6.52254 0.774833 6.45198 0.804106C6.38141 0.833378 6.31731 0.876281 6.26334 0.930358L4.00001 3.19369L1.73667 0.930358C1.6276 0.821288 1.47967 0.760012 1.32542 0.760012C1.17117 0.760012 1.02324 0.821288 0.914172 0.930358C0.805102 1.03943 0.743827 1.18736 0.743827 1.34161C0.743827 1.49586 0.805102 1.64379 0.914172 1.75286L3.59167 4.43036C3.64564 4.48443 3.70974 4.52734 3.78031 4.55661C3.85088 4.58588 3.92652 4.60095 4.00292 4.60095C4.07932 4.60095 4.15497 4.58588 4.22554 4.55661C4.29611 4.52734 4.36021 4.48443 4.41417 4.43036L7.09167 1.75286C7.31334 1.53119 7.31334 1.15786 7.08584 0.930358Z"
      fill="#5E6C84"
    />
  </svg>
);
